import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import {
  useHasSignupLevelCost,
  useIsSuggestedDonation,
} from "Signups/stateHooks";

PaymentStatusPill.propTypes = {
  paymentStatus: PropTypes.oneOf([
    "Paid",
    "MarkedAsPaid",
    "Unpaid",
    "PartiallyPaid",
    "Free",
    null,
    undefined,
  ]),
};

export default function PaymentStatusPill({ paymentStatus, signupItem }) {
  const hasSignupLevelCost = useHasSignupLevelCost();
  const isSuggestedDonation = useIsSuggestedDonation();
  const isPaid = paymentStatus === "Paid" || paymentStatus === "MarkedAsPaid";
  const hasSignupCost = hasSignupLevelCost || signupItem.fundIt.hasSignupCost;

  if (!hasSignupCost || signupItem.amount === 0) {
    return null;
  } else if (!paymentStatus) {
    return null;
  } else if (isSuggestedDonation && isPaid) {
    return <PaidWrapper>Donated</PaidWrapper>;
  } else if (!isSuggestedDonation && isPaid) {
    return <PaidWrapper>Paid</PaidWrapper>;
  } else if (!isSuggestedDonation && !isPaid) {
    return <UnpaidWrapper>Not Paid</UnpaidWrapper>;
  } else {
    return null;
  }
}

const Wrapper = styled.div`
  text-transform: uppercase;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: 600;
  color: rgb(255 255 255 / 90%);
  border-radius: 16px;
  margin-left: 8px;
`;

const PaidWrapper = styled(Wrapper)`
  background: #209e20;
`;

const UnpaidWrapper = styled(Wrapper)`
  background: #a5a5a5;
`;
